import StatusIcon from "common/components/StatusIcon"
import { DATA_KEYS_BALANCE } from "features/Contabilidad/pages/BalanceSituacion/constants"
import { nanoid } from "nanoid"
import React, { useRef } from "react"
import { frontendNumber } from "utils/frontendNumber"
import "../../pages/BalanceSituacion/styles.scss"
import "../../pages/Informes/styles.scss"
import TableHeader from "./TableHeader"

const BalanceTable = ({
  months,
  period,
  onTransformArrayData,
  dataKeySetup,
}: $TSMigrationFixMe) => {
  const ref = useRef()
  const BULLETPOINT_SECTION_CLASSES = DATA_KEYS_BALANCE[5].className

  return (
    <section
      className='tw-h-full tw-overflow-y-scroll tw-scrollbar-thin'
      // @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab...
      ref={ref}
    >
      <div className='tw-bg-simple-10 tw-mt-2'>
        <table
          className='tw-w-full data-[mensual=false]:tw-w-180 tw-mx-auto'
          data-mensual={Boolean(months.length > 1)}
        >
          {months.length > 1 && (
            <TableHeader
              months={months}
              period={period}
            />
          )}
          <tbody className='[&>tr:nth-child(6):tw-pb-2 tw-w-full'>
            {onTransformArrayData?.map((element: $TSMigrationFixMe) => {
              const isCuentaContableEmpresa =
                dataKeySetup[element.group]?.className ===
                BULLETPOINT_SECTION_CLASSES
              return (
                <tr
                  key={nanoid()}
                  className={`${
                    dataKeySetup[element.group]?.rowClassName
                  } tw-w-full hover:tw-bg-[#e9ecef]`}
                >
                  <th
                    className={`${
                      dataKeySetup[element.group]?.className ||
                      BULLETPOINT_SECTION_CLASSES
                    } ${
                      months.length > 1
                        ? "tw-min-w-75 [&>div>span]:tw-max-w-[350px]"
                        : "[&>div>span]:tw-max-w-128"
                    }`}
                    // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'number'.
                    colSpan='1'
                  >
                    {isCuentaContableEmpresa ? (
                      <div>
                        <StatusIcon status={3} />
                        <span> {element.description}</span>
                      </div>
                    ) : (
                      <span> {element.description}</span>
                    )}
                  </th>
                  {period ? (
                    months?.map((month: $TSMigrationFixMe) => {
                      const el = element.dataColumns?.find(
                        (ele: $TSMigrationFixMe) =>
                          ele.monthNumber === month.monthNumber
                      )
                      const cellValue =
                        element.description === "Activo" ||
                        element.description === "Pasivo"
                          ? null
                          : el?.importe
                      return (
                        <td
                          key={nanoid()}
                          className={`${
                            dataKeySetup[element.group]?.rowNumberClassName
                          } tw-text-right ${
                            parseFloat(cellValue) < 0 ? "!tw-text-danger" : ""
                          }
                            ${
                              Math.sign(cellValue) === -1
                                ? "tw-font-normal"
                                : ""
                            }`}
                        >
                          {cellValue === null ? "" : frontendNumber(cellValue)}
                        </td>
                      )
                    })
                  ) : (
                    <td
                      className={`tw-text-right ${
                        dataKeySetup[element.group]?.rowNumberClassName
                      }  ${
                        parseFloat(element.dataColumns[0]?.importe) < 0
                          ? "!tw-text-danger"
                          : ""
                      } ${
                        Math.sign(element.dataColumns[0]?.importe) === -1
                          ? "tw-font-normal"
                          : ""
                      }`}
                    >
                      {element.dataColumns[0]?.importe
                        ? frontendNumber(element.dataColumns[0]?.importe)
                        : ""}
                    </td>
                  )}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </section>
  )
}

export default React.memo(BalanceTable)
